import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Box,
  Flex,
  Text,
  Image,
  Button,
  HStack,
  VStack,
  Collapse,
  Badge,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';

import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

import { useColors } from './colors';
import { getMarketplaceLogo } from '../../../components/marketplaceLogo';

const StoreCard = ({ store }) => {
  const navigate = useNavigate();
  const [showSuppliers, setShowSuppliers] = useState(false);

  const { backgroundCardColor, textColor, subTextColor, supplierBgColor } = useColors();

  return (
    <Box
      bg={backgroundCardColor}
      borderRadius="xl"
      p={5}
      shadow="sm"
      _hover={{ shadow: 'md' }}
      transition="all 0.2s"
    >
      <VStack align="stretch" spacing={4}>
        <Flex align="center" gap={3}>
          <Image
            src={getMarketplaceLogo(store.marketplace.name)}
            alt={store.marketplace.name}
            h="30px"
            objectFit="contain"
          />
          <Box flex="1">
            <Text fontSize="lg" fontWeight="bold" color={textColor}>
              {store.name}
            </Text>
            <Text fontSize="sm" color={subTextColor}>
              {store.username}
            </Text>
          </Box>
        </Flex>

        <Box>
          <Text fontSize="md" color={textColor}>
            Listings: {store.listings}
          </Text>
          <Button
            variant="ghost"
            size="sm"
            rightIcon={showSuppliers ? <ChevronUpIcon /> : <ChevronDownIcon />}
            onClick={() => setShowSuppliers(!showSuppliers)}
            color={textColor}
            pl={0}
            _hover={{ bg: 'transparent', color: 'blue.500' }}
          >
            Suppliers
          </Button>
        </Box>

        <Collapse in={showSuppliers} animateOpacity>
          <Wrap spacing={2}>
            {store.suppliers.map((supplier, index) => (
              <WrapItem key={index}>
                <Badge
                  px={3}
                  py={1.5}
                  borderRadius="md"
                  bg={supplierBgColor}
                  color={textColor}
                  fontSize="sm"
                  textTransform="none"
                >
                  {supplier.altName}
                </Badge>
              </WrapItem>
            ))}
          </Wrap>
        </Collapse>

        <HStack spacing={4} pt={2}>
          <Badge
            colorScheme={store.isSyncEnabled ? 'green' : 'gray'}
            variant="subtle"
            px={3}
            py={1}
            borderRadius="full"
          >
            {store.isSyncEnabled ? 'Sync Active' : 'Sync Inactive'}
          </Badge>
          <Badge
            colorScheme={store.authentication.isRefreshTokenValid ? 'green' : 'red'}
            variant="subtle"
            px={3}
            py={1}
            borderRadius="full"
          >
            {store.authentication.isRefreshTokenValid ? 'Token Valid' : 'Token Invalid'}
          </Badge>
          <Button
            size="sm"
            variant="ghost"
            colorScheme="blue"
            ml="auto"
            onClick={() => navigate(`/admin/stores/${store._id}`)}
          >
            Edit
          </Button>
        </HStack>
      </VStack>
    </Box>
  );
};

export default StoreCard;
